"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderListItemContext = exports.RenderListGroup = void 0;
var react_1 = __importStar(require("react"));
var List_1 = require("../../Models/List");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var RenderTokensHostContext_1 = require("../RenderTokensHostContext");
var RenderListGroup = function (_a) {
    var e_1, _b;
    var listItems = _a.listItems, _c = _a.currentLevel, currentLevel = _c === void 0 ? 1 : _c;
    if (listItems.length === 0) {
        return null;
    }
    var distinctLists = [{ type: "undeclared", level: currentLevel, children: [] }];
    (0, tiny_invariant_1.default)(distinctLists[0], "Distinct lists is undefined");
    var currentList = distinctLists[0];
    try {
        for (var listItems_1 = __values(listItems), listItems_1_1 = listItems_1.next(); !listItems_1_1.done; listItems_1_1 = listItems_1.next()) {
            var listItem = listItems_1_1.value;
            if (currentList.level !== listItem.token.level) {
                if (currentList.children.length === 0) {
                    currentList.children.push({ nestedListItems: [] });
                }
                var lastChild = currentList.children[currentList.children.length - 1];
                (0, tiny_invariant_1.default)(lastChild, "Last child is undefined");
                lastChild.nestedListItems.push(listItem);
                continue;
            }
            if (currentList.level === listItem.token.level && currentList.type === "undeclared") {
                currentList.type = listItem.token.listType;
            }
            if (currentList.type === listItem.token.listType) {
                currentList.children.push({ item: listItem, nestedListItems: [] });
                continue;
            }
            if (currentList.type !== listItem.token.listType) {
                currentList = {
                    type: listItem.token.listType,
                    level: listItem.token.level,
                    children: [{ item: listItem, nestedListItems: [] }],
                };
                distinctLists.push(currentList);
                continue;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (listItems_1_1 && !listItems_1_1.done && (_b = listItems_1.return)) _b.call(listItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, distinctLists.map(function (list, listIndex) {
        var _a;
        var Tag = Object.freeze((_a = {},
            _a[List_1.ListItemType.Number] = "ol",
            _a[List_1.ListItemType.Bullet] = "ul",
            _a["undeclared"] = "ul",
            _a))[list.type];
        return (react_1.default.createElement(Tag, { key: listIndex }, list.children.map(function (listChild, listChildIndex) { return (react_1.default.createElement(MaybeWrap_1.default, { key: listChildIndex, wrapper: function (children) {
                if (listChild.item) {
                    return (react_1.default.createElement(RenderListItem, { listToken: listChild.item.token, childTokens: listChild.item.children }, children));
                }
                else {
                    return react_1.default.createElement("li", null, children);
                }
            } },
            react_1.default.createElement(RenderListGroup, { listItems: listChild.nestedListItems, currentLevel: list.level + 1 }))); })));
    })));
};
exports.RenderListGroup = RenderListGroup;
var RenderListItem = function (_a) {
    var listToken = _a.listToken, childTokens = _a.childTokens, children = _a.children;
    var RenderToken = (0, RenderTokensHostContext_1.useRenderTokensHostContext)().RenderToken;
    return (react_1.default.createElement(RenderListItemContextProvider, { nestedLists: children },
        react_1.default.createElement(RenderToken, { token: listToken, childTokens: childTokens })));
};
var RenderListItemContext = react_1.default.createContext(undefined);
var RenderListItemContextProvider = function (_a) {
    var nestedLists = _a.nestedLists, children = _a.children;
    return react_1.default.createElement(RenderListItemContext.Provider, { value: { nestedLists: nestedLists } }, children);
};
var useRenderListItemContext = function () {
    var context = (0, react_1.useContext)(RenderListItemContext);
    if (!context) {
        throw new Error("useRenderListItemContext must be used within a RenderListItemContextProvider");
    }
    return context;
};
exports.useRenderListItemContext = useRenderListItemContext;
